import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Bold = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M4.48815 2.64432H10.9445C11.565 2.64432 12.1206 2.73565 12.6112 2.91831C13.1163 3.10097 13.542 3.35388 13.8883 3.67705C14.2346 4.00022 14.4944 4.40067 14.6675 4.8784C14.8551 5.34207 14.9489 5.85493 14.9489 6.41696C14.9489 6.97899 14.8696 7.45672 14.7108 7.85014C14.5665 8.22952 14.3645 8.54566 14.1047 8.79857C13.8594 9.05149 13.5708 9.24117 13.2389 9.36763C12.9214 9.49409 12.5895 9.56434 12.2432 9.57839V9.70485C12.5751 9.70485 12.9287 9.76808 13.3039 9.89454C13.6935 10.021 14.047 10.2247 14.3645 10.5057C14.6964 10.7727 14.9706 11.124 15.187 11.5596C15.4035 11.9811 15.5117 12.508 15.5117 13.1403C15.5117 13.7304 15.4107 14.2854 15.2087 14.8053C15.0211 15.3111 14.7541 15.7537 14.4078 16.1331C14.0615 16.5125 13.6502 16.8146 13.174 17.0394C12.6978 17.2501 12.1783 17.3555 11.6155 17.3555H4.48815V2.64432ZM7.34539 14.995H10.793C11.3413 14.995 11.767 14.8615 12.0701 14.5945C12.3731 14.3135 12.5246 13.9131 12.5246 13.3932V12.6766C12.5246 12.1567 12.3731 11.7563 12.0701 11.4753C11.767 11.1942 11.3413 11.0537 10.793 11.0537H7.34539V14.995ZM7.34539 8.7775H10.3384C10.8579 8.7775 11.2619 8.64401 11.5506 8.37705C11.8392 8.09603 11.9835 7.70964 11.9835 7.21786V6.56449C11.9835 6.07271 11.8392 5.69334 11.5506 5.42638C11.2619 5.14536 10.8579 5.00485 10.3384 5.00485H7.34539V8.7775Z"
        fill={color}
      />
    </svg>
  )
})

export default Bold
